import * as analytics from '@eb/site-analytics';

import { eventsDuck } from '@eb/redux-destination';

import {
    GA_SAVE_EVENT_ACTION,
    GA_UNSAVE_EVENT_ACTION,
    GA_CB_EVENT_CARD_CATEGORY,
    GA_SEARCH_CATEGORY,
} from '../constants';

const {
    api: {
        saveEvent: saveEventApi,
        unsaveEvent: unsaveEventApi,
        loggedOutSaveRedirect,
    },
} = eventsDuck;

const { trackEventFromState } = analytics;

export const UPDATE_EVENT_SAVED_BY_YOU = 'updateEventSavedByYou';
export const updateEventSavedByYou = (eventId, savedByYou) => ({
    type: UPDATE_EVENT_SAVED_BY_YOU,
    payload: {
        eventId,
        savedByYou,
    },
});

const _loggedInSaveAction = (
    dispatch,
    state,
    eventId,
    shouldSave,
    isSearch,
) => {
    const gaTrackingCategory = isSearch
        ? GA_SEARCH_CATEGORY
        : GA_CB_EVENT_CARD_CATEGORY;

    if (shouldSave) {
        //optimistic state set
        dispatch(updateEventSavedByYou(eventId, true));

        return saveEventApi(eventId)
            .then(() => {
                trackEventFromState(state, {
                    category: gaTrackingCategory,
                    action: GA_SAVE_EVENT_ACTION,
                    label: eventId,
                    dimensions: {
                        eventId,
                    },
                });

                //Resolved promise so view knows if the event save was successful
                return Promise.resolve('success');
            })
            .catch(() => dispatch(updateEventSavedByYou(eventId, false)));
    }
    //optimistic state set
    dispatch(updateEventSavedByYou(eventId, false));

    return unsaveEventApi(eventId)
        .then(() => {
            trackEventFromState(state, {
                category: gaTrackingCategory,
                action: GA_UNSAVE_EVENT_ACTION,
                label: eventId,
                dimensions: {
                    eventId,
                },
            });

            //Resolved promise so view knows that the event unsave was successful
            return Promise.resolve('success');
        })
        .catch(() => dispatch(updateEventSavedByYou(eventId, true)));
};

export const saveEvent = (eventId, shouldSave, location, isSearch) => (
    dispatch,
    getState,
) => {
    const state = getState();
    const {
        auth: { isAuthenticated },
    } = state;

    if (isAuthenticated) {
        return _loggedInSaveAction(
            dispatch,
            state,
            eventId,
            shouldSave,
            isSearch,
        );
    }

    return loggedOutSaveRedirect(eventId, location);
};
